import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { hasAdminAccess } from './authorization';

export default function AdminRoute({ children }) {
  const location = useLocation();
  const { user } = useAuth();

  if (!hasAdminAccess(user)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children;
}
